(function () {
    'use strict';

    angular
        .module(app.modules.scoring.name)
        .directive(app.modules.scoring.directives.leaderboard, gnetLeaderboard);

    function gnetLeaderboard() {
        return {
            require: app.modules.scoring.directives.leaderboard,
            templateUrl: 'app/scoring/directives/leaderboard.html',
            scope: { gameId: '=' },
            controller: GNetLeaderboardCtrl,
            replace: true,
            link: postLink,
            controllerAs: 'vm',
            bindToController: true
        }

        function postLink(scope, iElement, iAttrs, gnetLeaderboardCtrl) {
            gnetLeaderboardCtrl.init(iElement, iAttrs);
        }
    }

    GNetLeaderboardCtrl.$inject = ['$timeout', '$scope', '$exceptionHandler', 'leaderboardHub', 'ngDialog', app.modules.outing.services.outings];
    function GNetLeaderboardCtrl($timeout, $scope, $exceptionHandler, leaderboardHub, ngDialog, ggOutingSvc) {
        /* Interface */
        var vm = this;
        vm.isProcessing = false;
        vm.getHoleClass = getHoleClass;
        vm.getScorecardClass = getScorecardClass;
        vm.formatWager = formatWager;
        vm.init = init;
        vm.roundEnabled = roundEnabled;
        vm.setActiveRound = setActiveRound;
        vm.toggleRow = toggleRow;
        vm.autoExpandSize = 8;
        vm.share = share;
        vm.shareURL = "";
        leaderboardHub = leaderboardHub();

        /* Implementation */
        var rSpinalCase = /[A-Z]/g;

        function share() {
            // Get Leaderboard Token
            ggOutingSvc.search.fetchOutingToken(vm.data.outingId).then(function (data) {
                if (data) {

                    vm.shareURL = app.Branding.http + app.Branding.rootURL + "#" + app.modules.outing.routes.leaderboard.path + "?tk=" + data.data.publicAccessToken;
                    try {

                        app.Member.Session.pageTemplates.fetch(app.modules.outing.templates.shareModal.templateId).then(function (template) {

                            ngDialog.open({
                                template: template
                               , plain: true
                               , closeByEscape: false
                               , closeByDocument: false
                               , showClose: true
                               , className: "slideup alert"
                               , scope: vm
                            });
                        });
                    } catch (e) {
                        console.log(e.toString());
                    }

                }
            });
        }

        function getHoleClass(hole, isMainScore) {
            var data = vm.data, toPar, type, scoringType, isNet, isBestBall, isStroke;
            if (data == null)
                return null;

            toPar = hole.grossToPar;
            type = data.type;
            scoringType = data.scoringType;
            isNet = data.isNet;
            isBestBall = scoringType == "BestBall",
            isStroke = scoringType == "Stroke";

            // Don't color code when (1) No Score, (2) IN/OUT/TOT column, (3) Is main score and game is a team bestball/stroke
            if (hole.gross == null || hole.number == "OUT" || hole.number == "IN" || hole.number == "TOT" ||
                (type == "Team" && (isBestBall || isStroke) && isMainScore))
                return null;

            return {
                eagle: toPar <= -2,
                birdie: toPar == -1,
                par: toPar == 0,
                bogey: toPar == 1,
                double: toPar == 2,
                other: toPar > 2,

                'best-ball': isBestBall && hole.isBestBall,
                'one-dot': isNet && hole.strokes == 1,
                'two-dot': isNet && hole.strokes == 2,
                'three-dot': isNet && hole.strokes == 3,
                'four-dot': isNet && hole.strokes >= 4,
                'one-plus': isNet && hole.strokes < 0
            }
        }
        function getScorecardClass(result) {
            var data = vm.data;
            return data ? [spinalCase(data.type), data.isNet ? 'net' : 'gross', spinalCase(data.scoringType), !result.showBackNine ? '' : 'backSide'].join(' ') : null;
        }
        function formatWager(amount) {
            var amt;
            if (amount) {
                amt = Math.round(amount, 0);
                if (amt < 0) {
                    amt = amt * -1;
                }
            }
            return amt;
        }
        function init(element, attrs) {
            leaderboardHub.on('getLeaderboard', onLeaderboardData);
            $scope.$watch('vm.gameId', gameIdWatchAction);
            $scope.$on('$destroy', onDestroy);
        }
        function roundEnabled(number) {
            return vm.data && number >= vm.data.startRound && number <= vm.data.endRound || false;
        }
        function setActiveRound(result, roundOrNumber) {
            result.rounds.forEach(function (round) {
                if (round == roundOrNumber || round.number == roundOrNumber)
                    round.active = true;
                else if (round.active === true)
                    round.active = false;
            });
        }
        function toggleRow(result) {
            if (angular.isUndefined(result.expanded)) {
                result.expanded = false; // create row
                $timeout(toggle); // toggle on next digest (after row created).
            }
            else
                toggle();

            function toggle() {
                if (result.expanded = !result.expanded)
                    setActiveRound(result, vm.data.currentRound);
            }
        }
        ////////////////////////////////////////

        // Helpers
        function spinalCase(name) {
            return name.replace(rSpinalCase, function (letter, pos) {
                return (pos ? '-' : '') + letter.toLowerCase();
            });
        }
        function restoreSpecialValues(newData, oldData) {
            var state = {}, key, value;

            if (newData && oldData) {
                oldData.results.forEach(save);
                newData.results.forEach(restore);
            }

            function save(result) {
                if (!angular.isUndefined(result.expanded)) {
                    state[key = oldData.grpGameId + ':' + result.grpTeamId + ':' + result.grpPlayerId] = result.expanded;
                    result.rounds.forEach(function saveRound(round) {
                        if (!angular.isUndefined(round.active))
                            state[key + ':' + round.grpRoundId] = round.active;
                    });
                }
            }

            function restore(result) {
                if (!angular.isUndefined(value = state[key = newData.grpGameId + ':' + result.grpTeamId + ':' + result.grpPlayerId])) {
                    result.expanded = value;
                    result.rounds.forEach(function restoreRound(round) {
                        if (!angular.isUndefined(value = state[key + ':' + round.grpRoundId]))
                            round.active = value;
                    });
                }
            }
        }

        // Events
        function onLeaderboardData(data) {
            // scope.$apply is not safe here.  Might be in digest already.
            $timeout(function () {
                if (data && vm.data && data.grpGameId == vm.data.grpGameId)
                    restoreSpecialValues(data, vm.data);
                vm.data = data;
            });
        }
        function onDestroy() {
            leaderboardHub.disconnect();
        }

        // Watchers
        function gameIdWatchAction(newValue, oldValue) {
            vm.loaded = false;
            onLeaderboardData(null);
            if (vm.gameId) {
                if (!vm.data) {
                    vm.isProcessing = true;
                }
                leaderboardHub.getLeaderboard(vm.gameId)
                    .catch(function onError(error) {
                        $exceptionHandler(error.message);
                    })
                    .finally(function onLoaded() {
                        vm.loaded = true;
                        vm.isProcessing = false;
                    });
            }
            else
                vm.loaded = true;
        }
    }
})();